import React, {
  useContext,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import { unregisterIcons, registerIcons } from "@fluentui/react/lib/Styling";
import PencilIcon from "../../../../../components/SVGComponents/PencilIcon";
import EyeIcon from "../../../../../components/SVGComponents/EyeIcon";
import EyeSlashIcon from "../../../../../components/SVGComponents/EyeSlashIcon";
import DeleteIcon from "../../../../../components/SVGComponents/DeleteIcon";
import AnnotationContext from "../../../../../context/annotation/AnnotationContext";
import ViewportContext from "../../../../../context/studyviewer/ViewportContext";
import StudyviewerState from "../../../../../context/studyviewer/StudyViewerState";
import studyviewerContext from "../../../../../context/studyviewer/StudyviewerContext";
import PencilInactiveIcon from "../../../../../components/SVGComponents/PencilInactiveIcon";
import InfoIcon from "../../../../../components/SVGComponents/InfoIcon";
import { StackScrollTool, WindowLevelTool } from "@cornerstonejs/tools";
import studyReportContext from "../../../../../context/studyreport/StudyReportContext";
import ConfigureModal from "../../ConfigureModal/ConfigureModal";
import SettingIcon from "../../../../../components/SVGComponents/SettingIcon";
import MoreIcon from "../../../../../components/SVGComponents/MoreIcon";
import CancelPathologyIcon from "../../../../../components/SVGComponents/CancelPathologyIcon";
import { ContextualMenu, TooltipHost } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import { COLORS } from "../../../../../constants/Constants";
import DynamicConfigureModal from "../../ConfigureModal/DynamicConfigureModal";
import { eventBus } from "../../../helper/initialData";
import $ from "jquery";
import CustomToolTipHost from "../../../../../components/CustomToolTipHost/CustomToolTipHost";
import themeContext from "../../../../../context/theme/ThemeContext";

const AddedPathology = (props) => {
  const {
    activeTool,
    setActiveTool,
    handlePencilClick,
    boundingBox,
    currentActiveTag,
    setCurrentActiveTag,
    activeId,
    setActiveId,
    activeColor,
    setActiveColor,
    hideBoundingBox,
    annotationDataAI,
    editWarning,
    setEditWarning,
    checkBoundingBoxExistPathalogy,
    setPreviousActiveTool,
    previousActiveTool,
    addedAnnotation,
    setAddedAnnotation,
    studyBoundingBox,
    restoreBoundingBox,
    addLockedAIPathology,
    activeViewportIndex,
    viewportSeriesData,
    boundingBoxMode,
    setBoundingBoxMode,
    setIsCropEnable
  } = useContext(ViewportContext);
  const [t] = useTranslation();
  const { disablePenEye } = useContext(studyReportContext);
  const {
    setAnnotationState,
    annotationState,
    setTabContent,
  } = useContext(AnnotationContext);
  const {studyParentId, showProbablilityScores} = useContext(studyviewerContext);


  const { getThemeColor,getAlterColor } = useContext(themeContext);

  const linkRef = useRef(null);

  const [flag, setFlag] = useState(true);
  const [showWarning, setWarning] = useState(false);
  const [showConfigureModal, setShowConfigureModal] = useState(false);
  const [showContextualMenu, setShowContextualMenu] = useState(false);
  const [leftShift, setLeftShift] = useState();
  const [topShift, setTopShift] = useState();
  const [delayHandler, setDelayHandler] = useState(null);

  useEffect(() => {
    eventBus.on("configureModalClick", (evtData) => {
      console.log("Event is listening...........");
      console.log(evtData);

      let element = $("#configure-path-modal-" + evtData.data.id);
      console.log(element);
      // const rect = element;
      // const left = rect.left + window.scrollX;
      // setLeftShift(left);

      $("#configure-path-modal-" + evtData.data.id).click();
      //console.log($("#configure-path-modal-"+evtData.data.id).position());
    });
  }, []);

  const onHideContextualMenu = useCallback(() => setShowContextualMenu(false), []);

  const hideContextMenu = () => {
    clearTimeout(delayHandler);
    setDelayHandler(
      setTimeout(() => {
        setShowContextualMenu(false);
      }, 300)
    );
  };

  useEffect(() => {
    clearTimeout(hideContextMenu);
  }, [showContextualMenu]);

  const handleSettingClick = () => {
    // console.log("ele is");
    let top =
      $("#configure-path-modal-" + props.id).offset().top -
      $(window).scrollTop();
    let left =
      $("#configure-path-modal-" + props.id).offset().left -
      $(window).scrollLeft();

    let tempAddedPathology = addedAnnotation;
    tempAddedPathology = tempAddedPathology.map((ele, index) => {
      if (ele.id == props.id) {
        ele.viewed = true;
        return ele;
      }
      return ele;
    });
    let tempAnnotationState = annotationState.annotations_stuff;
    tempAnnotationState = tempAnnotationState.map((ele, index) => {
      if (ele.id == props.id) {
        if (ele.viewed != null || ele.viewed != undefined) {
          ele.viewed = true;
        } else {
          ele["viewed"] = true;
        }
        return ele;
      } else {
        return ele;
      }
    });
    // console.log("--- updating");
    // console.log(tempAddedPathology);
    // console.log(tempAnnotationState);
    setAddedAnnotation(tempAddedPathology);
    setAnnotationState(() => {
      const newItem = { ...annotationState };
      newItem.annotations_stuff = tempAnnotationState;
      return newItem;
    });
    setLeftShift(left);
    setTopShift(top);
    setShowConfigureModal(true);
  };

  useEffect(()=>{
      if(activeTool != null 
        && activeTool != undefined 
        && activeTool != "RectangleROI" 
        && activeTool != StackScrollTool.toolName){
        setEditWarning(() => {
          let newVal = { ...editWarning };
          newVal.show = false;
          newVal.success = false;
          newVal.id = null;
          newVal.name = props.pathalogyName;
          return newVal;
        });
      }
  },[activeTool])

  const changeActiveTool = () => {
    setIsCropEnable(false);
    if (activeTool === "RectangleROI" && activeId == props.id) {
      // console.log("If");
      // setPencilFlag(false);
      setEditWarning(() => {
        let newVal = { ...editWarning };
        newVal.show = false;
        newVal.success = false;
        newVal.id = props.id;
        newVal.name = props.pathalogyName;
        return newVal;
      });
      setFlag(false);
      handlePencilClick(props, "RectangleROI");
      setActiveId(props.id);
      setPreviousActiveTool(activeTool);
      setActiveTool(StackScrollTool.toolName);
      setBoundingBoxMode(false);
      
    } else {
      // console.log("ELSE");
      setEditWarning(() => {
        let newVal = { ...editWarning };
        newVal.show = true;
        newVal.success = false;
        newVal.name = props.pathalogyName;
        newVal.id = props.id;
        newVal.color = props.backgroundColor;
        return newVal;
      });
      setFlag(true);
      handlePencilClick(props, "RectangleROI");
      setActiveId(props.id);
      setPreviousActiveTool(activeTool);
      setActiveTool("RectangleROI");
      setBoundingBoxMode(true);
      
    }
  
  };

  useEffect(() => {
    if(editWarning.show && viewportSeriesData[activeViewportIndex].study != studyParentId) {
      changeActiveTool();
    } 
  }, [activeViewportIndex])

  const handleCloseModal = () => {
    setShowConfigureModal((prev) => !prev);
  };

  useEffect(() => {
    let handler = () => {
      // console.log("calling handler");
      setShowConfigureModal(false);
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, [!showConfigureModal]);

  const getStackScrollOrEditIcon = () => {
    if(!(
      props.id == activeId &&
      boundingBoxMode &&
      activeTool != StackScrollTool.toolName
      && !(activeTool != "RectangleROI" 
      && activeTool != StackScrollTool.toolName)
    )){
      return true;
    }
    return false;
  }

  const menuItemsFunc = () => {
    const menuItems = [
      {
        key: "editArea",
        iconProps: { iconName: !getStackScrollOrEditIcon()?"StackScrollCustom":"EditCustomIcon", className: 'study-list-action-icon-class' },
        text: getStackScrollOrEditIcon()
          ? t("studyviewer.edit-area")
          : t("studyviewer.stack-scroll-tool"),
        onClick: (e) => changeActiveTool(),
      },
    ];
      if(props.showWarning){
      menuItems.push({
        key: "makeInvisible",
        iconProps: { iconName: !flag ? "EyeCustomSlashIcon" : "EyeCustomIcon", className: 'study-list-action-icon-class' },
        text: !flag
          ? t("studyviewer.make-visible")
          : t("studyviewer.make-invisible"),
        onClick: () => {
          hideBoundingBox(props.id, flag);
          setFlag((flag) => !flag);
        },
      })
    }
    
    // if(!props.isAI){
    menuItems.push({
      key: "removeTag",
      iconProps: { iconName: "Delete",style:{color:getThemeColor("primary-color")}, className: 'study-list-action-icon-class' },
      text: t("studyviewer.remove-tag"),
      onClick: (ev) => {
        setBoundingBoxMode(false);
        if(props.isAI){
          ev.stopPropagation();
          if(addLockedAIPathology(props.id, false)){
            props.addOrRemoveAnnotation(props.id, 0);
            //handleUpdateAnnotationState(props.id,false);
          }
          
        }else{
          props.addOrRemoveAnnotation(props.id, 0);
        }
        
      },
    });
    // }
    if (props.isAI) {
      menuItems.push({
        key: "restoreBoundingBox",
        iconProps: { iconName: "Refresh",style:{color:getThemeColor("primary-color"),fontSize:'13px'}, className: 'study-list-action-icon-class' },
        text: t("studyviewer.restore-bounding-box"),
        onClick: () => restoreBoundingBox(studyBoundingBox, props.id),
      });
    }
    return menuItems;
  };

  const contextMenuStyle = {
    root: {
     backgroundColor: getThemeColor('action-details-background'),
     borderRadius: "5px",
    border: "1px solid #585858",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
    },
    item: {
      selectors: {
      ":hover": {
        backgroundColor:'green'
      },
      },
    },
  };

  const onShowContextualMenu = (ev) => {
    ev.preventDefault(); // don't navigate

    clearTimeout(delayHandler);
    setDelayHandler(
      setTimeout(() => {
        setShowContextualMenu(true);
      }, 300)
    );

  };

  function hexToRgb(hex, check) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (result != null) {
      var r = parseInt(result[1], 16);
      var g = parseInt(result[2], 16);
      var b = parseInt(result[3], 16);
    }
    if (check) {
      return "rgb(" + r + "," + g + "," + b + ",0.5)";
    }
    return "rgb(" + r + "," + g + "," + b + ")";
  }

  const getAbbreviated = (str) => {
    var matches = str.match(/\b(\w)/g);
    var acronym = matches.join("");
    if (acronym.length > 2) {
      acronym = acronym.slice(0, 2);
    }
    return acronym;
  };

  const getColorForAI = (percent) => {
    let per = 100 - percent;
    return "hsl(" + per + ",100%,45%)";
  };

  const handleRemoveWarning = () => {
    setEditWarning(() => {
      let newVal = { ...editWarning };
      newVal.show = false;
      newVal.success = false;
      newVal.id = null;
      newVal.name = "";
      return newVal;
    });
    setPreviousActiveTool(activeTool);
    setActiveTool(StackScrollTool.toolName);
    setBoundingBoxMode(false);
  };

  const checkForLastAddedPathology = () => {
    if(addedAnnotation?.length > 4 && addedAnnotation[addedAnnotation.length-1]?.id == props.id){
      return true;
    }
    return false;
  }

  return (
    <div
      className="height-manage"
      style={{
        cursor: `${
          !props.showWarning && activeTool == StackScrollTool.toolName
            ? "pointer"
            : "default"
        }`,
      }}
      onClick={
        
        props.isAI
          ? () => {
            
              handleRemoveWarning();
              props.unSelectAIPathology(props.id);
            }
          : !props.showWarning
          ? changeActiveTool
          : null
      }
    >
      <div style={{ marginRight: "5px", marginLeft: "20px", marginTop:'5px' }}>
        <div
          className="selected-annotation-box"
          // style={{
          //   background:
          //     props.id == activeId
          //       ? hexToRgb(props.backgroundColor, true)
          //       : props.backgroundColor,
          //   border: `2px dashed ${hexToRgb(props.backgroundColor, false)}`,
          // }}
          style={{
            background: props.showWarning ? props.backgroundColor : getAlterColor("rgba(0,0,0,0.4)","rgba(0,0,0,0.2)"),
            border: `2px dashed ${props.backgroundColor}`,
            borderRadius: "8px",
          }}  
        >
          {/* {props.showConfigure && <div className="configure-tag">
            <span className="configure-tag-text">Configure</span>
        </div>} */}

          {props.isAI && (
            <div
              className="ai-tag"
              style={{
                right:
                  !disablePenEye && !props.showWarning
                    ? "1px"
                    : props.isAI
                    ? "-10px"
                    : "-16px",
                width: props.isAIEdited ? "35px" : "19px",
              }}
            >
              {!props.isAIEdited ? (
                <span className="ai-tag-text">{t("annotations.ai")} </span>
              ) : (
                <>
                  <CustomToolTipHost
                    content="This has been edited."
                    tooltipProps={{
                      calloutProps: {
                        styles: {
                          beak: { background: "#252525;" },
                          beakCurtain: { background: "#252525;" },
                          calloutMain: { background: "#252525;" },
                          borderRadius: "20%",
                        },
                      },
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <span className="ai-tag-text">{t("annotations.ai")} </span>
                      <span
                        style={{
                          marginLeft: "5px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <InfoIcon />
                      </span>
                    </div>
                  </CustomToolTipHost>
                </>
              )}
            </div>
          )}
          {!disablePenEye ? (
            props.showWarning ? (
              // <div
              //   className="configure-tag"
              //   onClick={() => setShowConfigureModal(true)}
              // >
              //   <span className="configure-tag-text">Configure</span>
              // </div>
              <></>
            ) : (
              <>
                <div
                  className="warning-tag"
                  style={{ right: props.isAI ? "-16px" : checkForLastAddedPathology() ? "-3px" : "-11px" }}
                >
                  <InfoIcon />
                </div>
              </>
            )
          ) : (
            <></>
          )}

          {(
            (!disablePenEye && props.showWarning) ||
            (!disablePenEye && props.isAI)
          ) ? (
            props.showConfigure && <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginRight: "10px",
                cursor: "pointer",
              }}
            >
              {props.showConfigure && (
                <div
                  id={`configure-path-modal-${props.id}`}
                  className="setting-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSettingClick();
                  }}
                >
                  <SettingIcon active={showConfigureModal} />
                  {showConfigureModal && (
                    <DynamicConfigureModal
                      id={props.id}
                      pathologyName={props.pathalogyName}
                      show={showConfigureModal}
                      onClickOutside={() => {
                        setShowConfigureModal(false);
                        // console.log("Removing tab content");
                        setTabContent([]);
                      }}
                      setShowConfigureModal={setShowConfigureModal}
                      message="Test"
                      screenX={leftShift}
                      screenY={topShift}
                      allData={props.allData}
                      handleCloseModal={handleCloseModal}
                      showConfigureModal={showConfigureModal}
                    />
                   
                  )}
                </div>
              )}
            </div>
          ): (<>{props.showConfigure && <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginRight: "10px",
              cursor: "not-allowed",
              opacity:'0.5'
            }}
          ><SettingIcon active={false} />
          
          </div>}
         
          </>)}

          
          <div className="pathalogy-name no-margin">{props.pathalogyName}
          {showProbablilityScores && props.isAI && process.env.REACT_APP_PROTECTED_MODE == "false" && <>&nbsp;-&nbsp;{props.aiPercent}%</>}
          </div>
          
          {/* {props.aiPercent != null && props.aiPercent != undefined && props.aiPercent > 0 && <div className="ai-percent-box"  style={{background:getColorForAI(props.aiPercent)}}>
          <span className="ai-percent-text">{props.aiPercent}%</span>
        </div>} */}
          <div
            ref={linkRef}
            onMouseEnter={(e) => {
              e.stopPropagation();
              onShowContextualMenu(e);
            }}
            onClick={(e) => {
              e.stopPropagation();
              setShowContextualMenu((prev)=>true)
            }}
            onMouseLeave={(e) =>{
              e.stopPropagation();
              hideContextMenu();
            }}
            className="extra-margin"
          >
            <MoreIcon />
            <div
              onMouseLeave={(e) => {
                e.stopPropagation();
                clearTimeout(delayHandler);
                setShowContextualMenu(false);
              }}
            >
              <ContextualMenu
                styles={contextMenuStyle}
                items={menuItemsFunc()}
                hidden={!showContextualMenu}
                target={linkRef}
                onItemClick={onHideContextualMenu}
                onDismiss={onHideContextualMenu}
              />
            </div>
          </div>
          {/* {!props.showWarning && !props.isAI && (
            <div
              className="icon-box"
              onClick={(e) => {
                e.stopPropagation();
                props.addOrRemoveAnnotation(props.id, 0);
              }}
            >
              <CancelPathologyIcon />
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default AddedPathology;
